import React from 'react';
import { ModelInfo } from '../../ModelPreviewComponents';

/**
 * Initialize duplicate count for a model
 * @param model - The model to initialize
 * @param setDuplicateCount - State setter for duplicate count
 */
export const initializeDuplicateCount = (
  model: ModelInfo,
  setDuplicateCount: React.Dispatch<React.SetStateAction<number>>
): void => {
  if (model.duplicates === undefined) {
    model.duplicates = 1;
  }
  setDuplicateCount(model.duplicates);
};

/**
 * Handle duplicate count change from input
 * @param e - Input change event
 * @param model - The model to update
 * @param setDuplicateCount - State setter for duplicate count
 */
export const handleDuplicateChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  model: ModelInfo,
  setDuplicateCount: React.Dispatch<React.SetStateAction<number>>
): void => {
  const count = parseInt(e.target.value);
  if (count >= 1) {
    setDuplicateCount(count);
    model.duplicates = count;
  }
};

/**
 * Handle duplicate count increment
 * @param duplicateCount - Current duplicate count
 * @param model - The model to update
 * @param setDuplicateCount - State setter for duplicate count
 */
export const handleDuplicateIncrement = (
  duplicateCount: number,
  model: ModelInfo,
  setDuplicateCount: React.Dispatch<React.SetStateAction<number>>
): void => {
  const newCount = duplicateCount + 1;
  setDuplicateCount(newCount);
  model.duplicates = newCount;
};

/**
 * Handle duplicate count decrement
 * @param duplicateCount - Current duplicate count
 * @param model - The model to update
 * @param setDuplicateCount - State setter for duplicate count
 */
export const handleDuplicateDecrement = (
  duplicateCount: number,
  model: ModelInfo,
  setDuplicateCount: React.Dispatch<React.SetStateAction<number>>
): void => {
  if (duplicateCount > 1) {
    const newCount = duplicateCount - 1;
    setDuplicateCount(newCount);
    model.duplicates = newCount;
  }
}; 